import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";

import { Collapse } from "antd";
import styled from "styled-components";

import { useModel } from "use-reaction";
import { user, getUser, loginOut } from "@/model/user";

import MenuLayout from "@/components/layouts/MenuLayout";

import { backToAdmin } from "@/api/sign-api";

import logo from "@/images/logo.png";
import user_img from "@/images/admin_icon_user.svg";

import { getEnv } from "@/libs/cfg";
import { view } from "@/model/view";
import { DashboardHeaderMobile } from "./DashboardHeaderMobile";
import OrganizationPauseBanner from "./OrganizationPauseBanner";
import "@/styles/dashboard/admin.less";
import "./DashboardLayout.less";
import { UserRole } from "@/types/enum";

const DashboardLayoutContainer = styled.div``;

interface props {
  children?: React.ReactNode;
}

const DashboardLayout = ({ children }: props) => {
  const history = useHistory();
  const { store, doAction } = useModel(user);
  const {
    store: { isMobile },
  } = useModel(view);

  const onSignOut = () => {
    doAction(loginOut);
    history.replace("/sign/in");
  };

  const handleAdmin = () => {
    backToAdmin().then((data) => {
      window.location.href = `${getEnv("ADMIN_HOST")}/auth/${data.token}`;
      doAction(loginOut);
    });
  };

  useEffect(() => {
    doAction(getUser);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {store?.fromAdmin && (
        <div className="access-container flex start">
          <i>
            Accessing{" "}
            {(store?.info?.firstName ?? "") +
              " " +
              (store?.info?.lastName ?? "")}{" "}
            account
          </i>
          {/*<Button type="primary" onClick={handleAdmin}>*/}
          {/*  Back to admin dashboard*/}
          {/*</Button>*/}
        </div>
      )}
      <DashboardLayoutContainer
        className={`admin-layout-container dashboard-layout-container flex ${(store?.fromAdmin && "admin-active") || ""
          } ${isMobile && "mobile"}`}
      >
        {isMobile ? (
          <DashboardHeaderMobile />
        ) : (
          <aside className="flex column">
            <Link to={store?.info?.roles?.includes(UserRole.ARTIST) ? "/dashboard/income" : "/dashboard/history"}>
              <img className="brand-logo" src={logo} alt="Counterpart" />
            </Link>
            <MenuLayout disabled={store.info?.status === 'deactived'} />
            <div className="admin-user-container site-drawer-render-in-current-wrapper">
              <Collapse expandIconPosition="right" defaultActiveKey={store?.info?.status === 'deactived' ? '1' : undefined}>
                <Collapse.Panel
                  header={
                    <div className="user-wrap flex">
                      <span translate="no">
                        <img src={store?.info?.avatar || user_img} alt="user" />
                        {(store?.info?.firstName ?? "") +
                          " " +
                          (store?.info?.lastName ?? "")}{" "}
                      </span>
                    </div>
                  }
                  key="1"
                >
                  {store.info?.status === 'active' &&
                    <>
                      <NavLink to="/dashboard/setting">Account settings</NavLink>
                      <NavLink to="/dashboard/transactions"> Transaction History </NavLink>
                      {
                        store?.roles?.includes("donor") &&
                        <NavLink to="/dashboard/recurring">Recurring Payment Settings</NavLink>
                      }
                      {store?.roles?.includes("artist") && (
                        <NavLink to="/dashboard/document">Documents</NavLink>
                      )}
                    </>
                  }
                  <span onClick={onSignOut}>Sign out</span>
                </Collapse.Panel>
              </Collapse>
            </div>
          </aside>
        )}

        <main
          className={`content-main ${history.location.pathname.match(/message/) && "msg"
            }`}
        >
          <OrganizationPauseBanner />
          {children}
        </main>
      </DashboardLayoutContainer>
    </>
  );
};

export default DashboardLayout;
